import {useContext} from 'react'

import Context from '@s-ui/react-context'

import {CONSENT_LINK_CLASS} from '../../config.js'
import {PanelOptionWrapper} from '../PanelOptionWrapper/index.js'

// eslint-disable-next-line react/prop-types
const ConsentLink = ({title, description, linkText, linkUrl}) => {
  return (
    <div className={CONSENT_LINK_CLASS}>
      <div className={`${CONSENT_LINK_CLASS}Title`}>{title}</div>
      <p className={`${CONSENT_LINK_CLASS}Description`}>{description}</p>
      <a className={`${CONSENT_LINK_CLASS}Anchor`} href={linkUrl}>
        {linkText}
      </a>
    </div>
  )
}

export const ExternalConsentsLinks = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {USER_FAVORITE_ADS_PATH_PATTERN, USER_SAVED_SEARCHES_PATH_PATTERN} = config.get('page')
  const {CONSENT_LINK_PRICEDROP_ENABLED} = config.get('user')

  return (
    <>
      <PanelOptionWrapper>
        <ConsentLink
          title={i18n.t('USER_PROFILE.CONSENT_LINK_ALERTS.TITLE')}
          description={i18n.t('USER_PROFILE.CONSENT_LINK_ALERTS.DESCRIPTION')}
          linkText={i18n.t('USER_PROFILE.CONSENT_LINK_ALERTS.LINK_TEXT')}
          linkUrl={USER_SAVED_SEARCHES_PATH_PATTERN}
        />
      </PanelOptionWrapper>
      {CONSENT_LINK_PRICEDROP_ENABLED && (
        <PanelOptionWrapper>
          <ConsentLink
            title={i18n.t('USER_PROFILE.CONSENT_LINK_PRICEDROP.TITLE')}
            description={i18n.t('USER_PROFILE.CONSENT_LINK_PRICEDROP.DESCRIPTION')}
            linkText={i18n.t('USER_PROFILE.CONSENT_LINK_PRICEDROP.LINK_TEXT')}
            linkUrl={`${USER_FAVORITE_ADS_PATH_PATTERN}/`}
          />
        </PanelOptionWrapper>
      )}
    </>
  )
}
